import React, {Component} from 'react';
import {InputItem, Modal,} from 'antd-mobile';
import "./style.less";
export default class TestCode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            codeVal:"",
        };
    }

    render(){
        return(
            <Modal
                visible={this.props.modal}
                className="codeModal"
                transparent
                maskClosable={false}
            >
                <div className="title">
                    <span>身份验证</span>
                    <i className="icon iconfont iconguanbi" onClick={()=>this.props.onClose()}/>
                </div>
                <p className="text">已向绑定银行卡开户手机号发送验证码</p>
                <div className="middle">
                    <InputItem
                        type='number'
                        placeholder="填写验证码"
                        className="inp"
                        onChange={(v)=>this.setState({codeVal: v,})}
                        value={this.state.codeVal}
                        ref={el => this.inputRef = el}
                        maxLength={6}
                    >验证码</InputItem>
                    <button
                        className="again"
                        style={this.props.getCodeDisabled ? {color:"#fff",border:"none",background:"#dddddd"}:null}
                        disabled={this.props.getCodeDisabled}
                        onClick={()=>this.props.againEvent()}
                    >{this.props.getCodeText}</button>
                </div>
                <button onClick={()=>this.props.codeSubmit(this.state.codeVal)}>提交</button>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/TestCode/index.js